export default __webpack_public_path__ + "static/teads-d7ab4476784a7f67508debe8fcec5fd9.svg";